module.exports = __webpack_public_path__ + "static/media/design-1.bd61a264.svg";